import { css } from '@/styled-system/css';

export const popupModalStyles = css({
  maxWidth: '1200px !important',
  width: {
    base: '100% !important',
    md: 'calc(100vw - 32px) !important',
    xl: 'min(1200px, calc(100vw - 32px)) !important',
  },
  '& > div': {
    width: '100% !important',
  },
});
